export default __webpack_public_path__ + "1ce4b46bee07e36c1a386dcd1fe51781.png";